import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { DailySummary } from '../../types/report';
import { format, parseISO } from 'date-fns';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

interface TripTrendChartProps {
  data: DailySummary[];
}

export const TripTrendChart: React.FC<TripTrendChartProps> = ({ data }) => {
  const chartData = {
    labels: data.map((d) => format(parseISO(d.date), 'MMM dd')),
    datasets: [
      {
        label: 'Professional',
        data: data.map((d) => d.professional_km),
        borderColor: '#70AD47',
        backgroundColor: 'rgba(112, 173, 71, 0.1)',
        fill: true,
        tension: 0.4,
      },
      {
        label: 'Personal',
        data: data.map((d) => d.personal_km),
        borderColor: '#FFC000',
        backgroundColor: 'rgba(255, 192, 0, 0.1)',
        fill: true,
        tension: 0.4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value: any) => `${value} km`,
        },
      },
    },
  };

  return (
    <div style={{ height: '300px' }}>
      <Line data={chartData} options={options} />
    </div>
  );
};
